<template>
  <layout-main-inner
    v-loading="loading"
    title="标签申请">
    <div slot="action">
      <el-button
        type="primary"
        @click="addtagapply">申请标签</el-button>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <!-- <el-input
          v-model="config.vendorName"
          clearable
          placeholder="请输入商家名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input> -->
        <el-button
          type="primary"
          @click="handleCurrentChange(1)">刷新</el-button>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="申领物料"
          min-width="100"
          prop="tagName"> </el-table-column>
        <el-table-column
          label="申领数量"
          min-width="100"
          prop="tagCount"> </el-table-column>
        <el-table-column
          label="发放数量"
          min-width="100"
          prop="grantTagCount"> </el-table-column>
        <el-table-column
          label="发放序号"
          min-width="100"
          prop="status">
          <template slot-scope="{ row }">
            <template v-if="!!row.beginTagNo">{{ row.beginTagNo }}-{{ row.endTagNo }}</template>
          </template>
        </el-table-column>
        <el-table-column
          label="申领状态"
          min-width="100"
          prop="status">
          <template slot-scope="{ row }">{{ row.status | tagApplyStatusName() }}</template>
        </el-table-column>
        <el-table-column
          label="申领时间"
          width="150">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
export default {
  name: 'AppraisalTagApply',
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, vendorName: '' }
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    addtagapply() {
      this.$prompt('请输入申请标签数量', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /^[1-9]\d*$/, inputErrorMessage: '请输入正整数',
        beforeClose: (action, instance, done) => {
          if (action === 'cancel' || action === 'close') {
            done()
          } else {
            this.loading = true
            this.$$appraiseApi.addtagapply({ tagCount: instance.inputValue })
              .then(res => {
                this.loading = false
                const { result, message } = res.data
                if ([0].includes(result)) {
                  this.$message.success('申请标签成功')
                  done()
                  this.getlist()
                } else {
                  this.$message.error(message)
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error(err.message)
              })
          }
        }
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$$appraiseApi.gettagapplys({ ... this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.list = records.map(i => ({ ...i, tagName: '鉴定标签' }))
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
